import React from 'react'

const Copyright = () => {
    return (
        <>
             <div className="copyright">© 2025 Cybercrime Investigation &amp; Intelligence Summit All rights reserved.</div>
        </>
    )
}

export default Copyright